// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__JJJoP","logo":"styles_logo__r_iRn"};